import { Link } from "react-router-dom";
import localeText from "../../../../locale";

const FooterColumn = ({ heading, links, id }) => {
  return (
    <>
      <div className="text-md font-bold mb-3">{heading}</div>
      <div className="flex flex-column gap-3">
        {links.map((link) =>
          link.url.startsWith("/") ? (
            <Link
              to={link.url}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              key={`link-${id}-${link.id}`}
              className="text-sm font-medium"
              style={{ color: "#D9E3FF" }}
            >
              {link.text}
            </Link>
          ) : (
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              key={`link-${id}-${link.id}`}
              className="text-sm font-medium"
              style={{ color: "#D9E3FF" }}
            >
              {link.text}
            </a>
          )
        )}
      </div>
    </>
  );
};
const LandingFooterLinks = () => {
  const footerColumns = [
    {
      heading: "Extraconomy",
      links: [
        {
          text: localeText("discoverExtraconomy"),
          url: "https://business.extraconomy.com/",
          id: 10,
        },
        /* { text: localeText("workWithUs"), url: "/comingsoon", id: 11 }, */
        { text: localeText("rewardsProgram"), url: "/salepromoter", id: 12 },
        { text: "Extracoin", url: "https://extracoin.site/", id: 13 },
      ],
      id: 1,
    },
    {
      heading: localeText("makeMoneyWithUs"),
      links: [
        { text: localeText("sellWithUs"), url: "/landing", id: 20 },
        { text: localeText("becomeAffiliate"), url: "/businesspartner", id: 21 },
      ],
      id: 2,
    },
    {
      heading: localeText("ourPolicies"),
      links: [
        /*  { text: localeText("shippingPolicy"), url: "/comingsoon", id: 30 }, */
        { text: localeText("privacyPolicy"), url: "/privacy", id: 31 },
        /*  { text: localeText("returnPolicy"), url: "/comingsoon", id: 32 }, */
        /* { text: localeText("returnsAndRefunds"), url: "/comingsoon", id: 33 }, */
      ],
      id: 3,
    },
  ];
  return (
    <>
      {footerColumns.map((column) => (
        <div key={column.id} className="flex flex-column gap-3 col-12 md:col">
          <FooterColumn id={column.id} heading={column.heading} links={column.links} />
        </div>
      ))}
    </>
  );
};
export default LandingFooterLinks;
